import { render } from "./Budget.vue?vue&type=template&id=b6b886ba&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"

import "./Budget.vue?vue&type=style&index=0&id=b6b886ba&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b886ba"]])

export default __exports__